"use strict";

PF.Field.Select = class Select extends PF.Field {
    static get options() {
        return {
            html: PF.Field.Select.templates,
            popupConfig: {
                title: 'Выберите значение'
            },
            tooltipConfig: {
                shift: [
                    [20, 0],
                    [20, 16],
                    [-12, 0],
                    [-12, 0]
                ]
            },
            radioConfig: {
                listConfig: {
                    title: '',
                    modelsConfig: {}
                }
            },

            label: "Выберите значение",
            model: new PF.Model({}),
            key: 'value',

            showInfo: true,
            helper: '',

            errors: {}
        };
    }


    static get templates() {
        return {
            //language=HTML
            wrapper: `
				<div class="pf-select-wrapper">
					<div class="pf-select" pf="select">
						<div class="pf-select-label" pf="label"></div>
						<div class="pf-selected" pf="selected">&nbsp;</div>
					</div>
					<div class="underline">
						<hr class="normal"/>
						<hr class="focus"/>
					</div>
					<div class="info" pf="info">&nbsp;</div>
				</div>
			`,
            //language=HTML
            popupContent: `
				<div class="" pf="radioGroup"></div>
			`,
        };
    }


    init() {
        this.dom.loads(this.html);
        this.dom.element.append(this.dom.wrapper);

        if (PF.H.isBigScreen()) {
            this.popup = new PF.Popup.Tooltip({
                dom: {
                    content: this.dom.popupContent,
                    anchor: this.dom.element,
                },
                ...this.tooltipConfig,
            });
            this.popup.on('opening', () => {
                this.dom.info.hide();
            });
            this.popup.on('closed', () => {
                this.dom.info.show();
            });
        } else {
            this.popup = new PF.F7Popup({
                dom: { content: this.dom.popupContent },
                ...this.popupConfig
            });
        }

        this.popup.dom.popup.addClass('pf-select-tooltip');
        this.dom.select.on('click', () => {
            this.popup.open();
        });

        this.group = new PF.Field.RadioGroup({
            dom: { element: this.dom.radioGroup },
            ...this.radioConfig,
            model: this.model,
            key: this.key,
            select: this
        });

        this.bindDom({ wrapper: 'class:error' }, 'error', (e) => e !== '');
        this.bindDom({ wrapper: 'class:focus' }, 'popup.opened');
        this.bindDom({ info: 'html' }, ['helper', 'error'], (h, e) => e !== '' ? e : h !== '' ? h : '&nbsp;');
        this.bindDom({ info: 'show' }, 'showInfo');
        this.bindDom({ label: 'html' }, 'label');
        this.bindDom({ select: 'class:active' }, 'model.' + this.key, (v) => v !== null && v !== undefined && v.isNull() !== true);
        this.bindDom({ selected: 'content' }, 'group.selected', (s) => {
            if (s === undefined) {
                return this.group.nullItem.dom.itemInner
            }
            return s.dom.itemInner
        });

        this.model.onChange(this.key, () => this.validate(), true);
        this.on('group.list.*.dom.item.click', () => {
            this.popup.close();
        });

        this.group.list.on('add-success', (newItem) => {
            this.model.setData(this.key, newItem);
        });

        this.popup.on('opened', () => {
            this.group.list.searchShow = true;
            this.group.list.searchString.setFocus();
        });
    }

    validate(silent, error = undefined) {
        if (this.required === true) {
            if (this.model.get(this.key, null, null, (v) => v.toJSON()) === null) {
                return super.validate(silent, this.errors.required);
            }
        }
        return super.validate(silent, error);
    }
};